import * as React from 'react';

import { Breadcrumbs } from './parts/Breadcrumbs';
import { DeveloperInfo } from './parts/DeveloperInfo';
import { Heading } from './parts/Heading';
import * as style from './style.css';
import { IBreadcrumb } from '../../../offer';
import { IDeveloperInfo } from '../../../types/developerInfo';

export interface IHeaderDeveloperRedesignedProps {
  breadcrumbs: IBreadcrumb[];
  developerInfo: IDeveloperInfo;
}

export const HeaderDeveloperRedesigned: React.FC<IHeaderDeveloperRedesignedProps> = ({
  breadcrumbs,
  developerInfo,
}) => {
  return (
    <div data-name="HeaderDeveloperRedesigned" className={style['container']}>
      <div itemScope className={style['wrapper']} itemType="http://schema.org/BreadcrumbList">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <Heading developerUrl={developerInfo.url as string} developerName={developerInfo.name} />
        <DeveloperInfo developerInfo={developerInfo} />
      </div>
    </div>
  );
};
